import { render, staticRenderFns } from "./LinkSns.vue?vue&type=template&id=5f67a7fe&"
import script from "./LinkSns.vue?vue&type=script&lang=ts&"
export * from "./LinkSns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports